export default {
    navHome: "홈",
    navProspect: "잠재 고객",
    navCompanies: '회사',
    navEnrich: '데이터 보강',
    navIntent: "웹사이트 의도",
    navSequence: "시퀀스",
    navInbox: "받은편지함",
    navInboxDesc: "이메일과 LinkedIn 메시지를 한 곳에서 읽고 답장",
    inboxSearchPlaceholder: "대화 검색",
    inboxEmptyState: "아직 대화가 없습니다. 시퀀스가 시작되면 회신이 여기에 표시됩니다.",
    inboxEmptyConnectCta: "시퀀스 설정하기",
    channelEmail: "이메일",
    channelLinkedIn: "링크드인",
    inboxMsgYou: "나",
    inboxSelectThreadTitle: "대화 선택",
    inboxThreadErrorTitle: "이 대화를 불러올 수 없습니다",
    inboxThreadErrorHint: "이 스레드에 활성 채널 연결이 없거나 데이터를 더 이상 사용할 수 없습니다.",
    inboxComposerHint: "⌘ + Enter로 보내기",
    inboxToggleProspect: "잠재 고객 정보 전환",
    inboxChannelFilter: "채널 필터",
    inboxProspectContact: "연락처",
    inboxProspectSequence: "시퀀스",
    inboxProspectActivity: "활동",
    inboxProspectLastInbound: "최근 답장",
    inboxProspectLastOutbound: "최근 발송",
    inboxProspectStatus: "상태",
    inboxProspectNoContact: "연락처 정보가 없습니다.",
    inboxBulkSelected: "선택됨",
    inboxBulkMarkRead: "읽음",
    inboxBulkToggle: "대화 선택",
    inboxTabProfile: "프로필",
    inboxTabActivity: "활동",
    inboxActivityEmpty: "이 대화에 대한 활동이 없습니다.",
    inboxInsertVariable: "변수",
    inboxVarFullName: "전체 이름",
    inboxVarCompany: "회사",
    inboxVarTitle: "직책",
    inboxSequenceStep: "단계",
    inboxSequenceRunning: "실행 중",
    inboxSequencePaused: "일시정지",
    inboxSequenceFinished: "완료됨",
    inboxSequenceArchived: "보관됨",
    inboxAsideConversations: "개 대화",
    inboxBulkToggleAll: "이 페이지 전체 선택",
    inboxSortBy: "정렬",
    inboxSortRecent: "최신순",
    inboxSortOldest: "오래된순",
    inboxSortSender: "보낸 사람 (A→Z)",
    inboxSortSubject: "제목 (A→Z)",
    inboxSortReplied: "답장된 항목 우선",
    last_message_at: "최신 메시지",
    first_message_at: "첫 메시지",
    reference_id: "보낸 사람",
    subject: "제목",
    inboxAccountSingular: "개 계정",
    inboxAccountPlural: "개 계정",
    inboxRecentReplies: "최근 답장",
    inboxConnectedAs: "연결 계정",
    inboxActionInterested: "관심 있음으로 표시",
    inboxActionMarkAll: "모두 표시",
    inboxSelectThreadHint: "메시지를 보려면 대화를 선택하세요.",
    inboxReplyPlaceholder: "답장 입력…",
    inboxSuggestReply: "AI 답장 추천",
    inboxSend: "보내기",
    inboxFilterAll: "전체",
    inboxFilterUnread: "읽지 않음",
    inboxFilterReplied: "답장함",
    inboxFilterSnoozed: "스누즈",
    inboxFilterClosed: "닫힘",
    inboxActionSnooze: "스누즈",
    inboxActionMeetingBooked: "미팅 예약됨",
    inboxActionNotInterested: "관심 없음",
    inboxActionArchive: "아카이브",
    inboxActionStopSequence: "시퀀스 중지",
    inboxArchetypeConcise: "간결",
    inboxArchetypeWithCta: "CTA 포함",
    inboxArchetypeQuestionBack: "반문",
    actions: "작업",
    loading: "로딩 중…",
    navService: "서비스",
    navAccountCredit: "계정 크레딧",
    navSetting: "설정",
    navSequenceDetail: "시퀀스 상세 정보",
    companyDetail: "회사 상세 정보",


    // nav desc
    filterYourSearchToFindPreciselyTargeted: "정확하게 타겟팅된 회사 목록을 찾도록 검색 필터링하기",
    filterYourSearchToFindHighlySpecific: "매우 구체적인 타겟팅 리드 그룹을 찾도록 검색 필터링하기",
    instantlyEnhanceYourData: "다양한 소스의 가치 있는 인사이트와 핵심 세부 정보를 추가하여 데이터 즉시 강화하기",
    transformAnonymousWebsiteTrafficInto: "익명의 웹사이트 트래픽을 실시간 식별을 통해 B2B 리드로 전환하기",
    personalizeYourOutreach: '아웃리치를 자동화하고 개인화하여 시간을 절약하고 잠재 고객을 참여시키기',
    comprehensiveBusinessSolutions: '고객의 니즈에 맞는 포괄적인 비즈니스 솔루션 및 지원 서비스',


    discoverAndConnectWithPotentialBuyers: "잠재적 구매자 발견 및 연결하기",
    activelySeekingYourSolutionToday: "오늘 적극적으로 당신의 솔루션을 찾고 있는",
    Market_Intent: "시장 의도",
    Tools: "도구",
    technologyLookup: "기술 조회",
    domainLookup: "도메인 조회",
    emailVerification: "이메일 확인",
    upgrade: "업그레이드",
    helpCenter: "고객센터",
    contactUs: "문의하기",
    feedback: "피드백",
    hello: "안녕하세요",
    clickToChange: "클릭하여 변경",
    yourProfile: "내 프로필",
    currentUsage: "현재 사용량",
    upgradePlan: "플랜 업그레이드",
    integrations: "통합",
    featureRequests: "기능 요청",
    change: "변경",
    en: "English",
    cn: "中文（简）",
    tw: "中文（繁）",
    logout: "로그아웃",
    switchLanguage: "언어가 성공적으로 전환되었습니다",

    // button operation
    btnEdit: "수정",
    btnDelete: "삭제",
    btnCancel: '취소',
    btnFilters: "필터",
    btnView: '보기',
    btnAdd: '추가',
    btnRemove: '제거',

    // 操作提示
    removeSuccessfully: "성공적으로 제거되었습니다",
    saveSuccessfully: "성공적으로 저장되었습니다",
    createSuccessfully: "성공적으로 생성되었습니다",


    // 系统popup
    unableToProcessPayment: '결제 처리 불가: 최근 청구서에 대한 결제를 완료할 수 없습니다.',
    billingSettings: "청구 설정",

    // wallet
    topupCredit: "크레딧 충전",
    autoTopup: "자동 충전",
    lastCalculated: "마지막 계산일",
    Enabled: "활성화됨",
    Disabled: "비활성화됨",

    // user
    btnUpgrade: "업그레이드",

    // app update toast
    newVersionAvailable:
      "<strong>새 버전이 출시되었습니다</strong> — 새로고침하여 최신 기능과 수정 사항을 받으세요. 이 페이지에서 저장되지 않은 변경 사항은 손실될 수 있습니다.",
    Reload: "새로고침",
    // TODO: translate (placeholders copied from en.js)
    inboxStatsToday: "Today",
    inboxStatsReplies: "Replies",
    inboxStatsPending: "Pending",
    inboxStatsActiveSequences: "Active sequences",
    inboxOpenEmpty: "Open the inbox to see your latest replies.",
    inboxRefresh: "Refresh inbox",
    inboxSuggestFollowUp: "Suggest follow-up",
    inboxInsightAge: "Age",
    inboxSuggestModePick: "Choose draft type",
    inboxSuggestModeReply: "Reply (prospect wrote last)",
    inboxSuggestModeFollowUp: "Follow-up (we wrote last)",
    inboxSuggestModeAuto: "Auto (detect from thread)",
    inboxFilterArchived: "Archived",
    inboxFilterDone: "Done",
    inboxStatusMeetingBooked: "Meeting booked",
    inboxStatusNotInterested: "Not interested",
    inboxStatusInterested: "Interested",
    inboxFilterOpen: "Active",
    inboxMsgSent: "Sent",
    inboxClickToOpen: "Click to open",
    inboxKpiSentToday: "Sent today",
    inboxKpiUnread: "Unread",
    inboxKpiRepliedToday: "Replies",
    inboxKpiSentWeek: "Sent this week",
    inboxKpiInbox: "in inbox",
    inboxKpiTotal: "total",
    inboxGlanceTopSequences: "Top sequences (30 days)",
    inboxLinkBtn: "Link",
    inboxLinkPromptUrl: "Link URL",
    inboxLinkPromptErr: "Enter a URL starting with http(s)://",
    inboxComposerDropHint: "Drop to attach",
    inboxFilterChannel: "Channel",
    inboxFilterCredential: "Credential",
    inboxFilterSequence: "Sequence",
    inboxFilterStatus: "Status",
    inboxFilterClassification: "Reply type",
    inboxFilterDateRange: "Date range",
    inboxFilterDateRangePh: "Pick a date range",
    inboxFilterClass_real: "Real replies only",
    inboxFilterClass_bounce: "Bounces",
    inboxFilterClass_auto_reply: "Auto-replies",
    inboxClassBounce: "Bounce",
    inboxClassBounceHint: "Delivery failed — this isn't a real reply",
    inboxClassAutoReply: "Auto-reply",
    inboxClassAutoReplyHint: "Automated out-of-office / vacation responder",
    inboxStepEvents: "events",
    inboxBulkMarkUnread: "Unread",
    inboxBulkInterested: "Interested",
    inboxBulkNotInterested: "Not interested",
    inboxSnoozeDialogTitle: "Snooze until",
    inboxSnoozeCustom: "Pick a custom date and time",
    inboxSnoozeCustomPh: "Select date & time",
    inboxSnoozeConfirm: "Snooze",
    inboxSnoozePreset1h: "Later today (1h)",
    inboxSnoozePreset4h: "Later today (4h)",
    inboxSnoozePresetTom: "Tomorrow morning",
    inboxSnoozePresetMon: "Next Monday",
    inboxSnippetBtn: "Snippets",
    inboxSnippetSearch: "Search snippets",
    inboxSnippetNew: "New snippet",
    inboxSnippetManage: "Manage",
    inboxSnippetCreate: "Create your first snippet",
    inboxSnippetCreateTitle: "New snippet",
    inboxSnippetEditTitle: "Edit snippet",
    inboxSnippetManager: "Manage snippets",
    inboxSnippetEmpty: "No saved snippets yet.",
    inboxSnippetFieldName: "Name",
    inboxSnippetFieldChannel: "Channel (optional)",
    inboxSnippetFieldBody: "Body",
    inboxSnippetChannelAny: "Any channel",
    inboxSnippetNamePh: "e.g. Friendly follow-up",
    inboxSnippetBodyPh: "Hi {{first_name}}, just following up…",
    btnSave: "Save",
    inboxProspectTracking: "Tracking",
    inboxOpened: "Opened",
    inboxClicked: "Clicked",
    inboxLast: "last",
    of: "of",
    inboxAttachBtn: "Attach",
    inboxAttachTooBig: "Total attachment size exceeds 24MB.",
    noData: "No results",
    inboxCopy: "Copy",
    inboxCopied: "Copied",
    inboxCopyEmail: "Copy email",
    inboxCopiedEmail: "Email copied",
    inboxCopyPhone: "Copy phone",
    inboxCopiedPhone: "Phone copied",
    inboxOpenLinkedIn: "Open LinkedIn",
    inboxOpenTwitter: "Open X / Twitter",
    inboxProspectCompany: "Company",
    inboxProspectInsights: "Insights",
    inboxInsightMessages: "Messages",
    inboxInsightSince: "Open",
    inboxAgeToday: "Today",
    inboxEmptyTitle: "No conversations yet",
    inboxSelectionPicker: "Selection options",
    inboxSelectionTitle: "Select conversations",
    inboxSelectThisPage: "This page",
    inboxSelectAll: "All conversations",
    inboxSelectCustom: "Custom",
    inboxSelectAllHint: "Selecting beyond this page fetches additional pages from the server.",
    applySelection: "Apply",
    theQuantityCannotBeZero: "Pick a non-zero count",
    inboxCompanyName: "Name",
    inboxCompanyIndustry: "Industry",
    inboxCompanySize: "Size",
    inboxCompanyLocation: "Location",
    inboxCompanyWebsite: "Website",
    inboxCompanyLinkedIn: "LinkedIn",
    inboxShowTrimmed: "Show trimmed content",
    inboxShowTrimmedHint: "Show the rest of this message",
    inboxFieldTo: "To",
    inboxFieldToPh: "recipient@example.com",
    inboxFieldToLinkedInPh: "Recipient",
    inboxFieldCc: "Cc",
    inboxFieldCcPh: "cc@example.com, …",
    inboxFieldBcc: "Bcc",
    inboxFieldBccPh: "bcc@example.com, …",
    inboxFieldSubject: "Subject",
    inboxFieldSubjectPh: "Subject",
    inboxFieldLocked: "Auto-filled — cannot edit",
    inboxTrackSent: "Sent",
    inboxTrackSentHint: "Messages we sent in this thread",
    inboxTrackReplies: "Replies",
    inboxTrackRepliesHint: "Inbound messages from the prospect",
    inboxTrackOpens: "Opens",
    inboxTrackOpensHint: "Times the recipient opened a tracked message",
    inboxTrackClicks: "Clicks",
    inboxTrackClicksHint: "Tracked links the recipient clicked",
    inboxTrackReads: "Reads",
    inboxTrackReadsHint: "Times the recipient read this thread (LinkedIn read receipts)",
    inboxTrackReactions: "Reactions",
    inboxTrackReactionsHint: "Reactions on our outbound messages",
    inboxMsgNoOpenYet: "No opens recorded yet",
    inboxMsgNoClickYet: "No clicks recorded yet",
    inboxActivityReplyReceived: "Reply received",
    inboxActivityOpenRecorded: "Email opened",
    inboxActivityClickRecorded: "Link clicked",
    inboxActivitySendEmail: "Email sent",
    inboxActivitySendLinkedIn: "LinkedIn message sent",
    inboxActivitySendInvite: "LinkedIn invite sent",
    inboxActivityFailed: "failed",
    inboxComposerExpand: "Expand composer",
    inboxComposerCollapse: "Collapse composer",
    inboxComposerMinimise: "Minimise composer",
    inboxComposerRestore: "Restore composer",
    inboxComposerReply: "Reply…",
    inboxReplyModeReply: "Reply",
    inboxReplyModeReplyAll: "Reply all",
    inboxRecipientNoMatch: "Type an email and press Enter",
    inboxSignatureToggle: "Toggle signature",
    inboxSignatureTitle: "Email signature",
    inboxSignaturePh: "Best regards,\nYour name",
    inboxSignatureOn: "Signature ON — click to remove",
    inboxSignatureOff: "Signature OFF — click to insert",
    inboxSignatureRightClickEdit: "right-click to edit",
    inboxSignatureRightClickHint: "Tip: right-click the signature button to edit.",
    Refresh: "Refresh",
    Show: "Show",
    Hide: "Hide",
    Next: "Next",
};